var _path, _path2, _rect, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36159 -6.10352e-05C1.76062 -6.10352e-05 1.27344 0.48712 1.27344 1.08809V29.4572C1.27344 30.0582 1.76062 30.5454 2.36159 30.5454H25.6398C26.2408 30.5454 26.728 30.0582 26.728 29.4572V1.08809C26.728 1.08328 26.7279 1.07848 26.7279 1.07368V5.09101L21.637 0.000101089H25.6588C25.6525 -6.84761e-06 25.6462 -6.10352e-05 25.6398 -6.10352e-05H2.36159Z",
    fill: "#E4E7EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6367 9.15527e-05V5.09085H26.7276L21.6369 9.15527e-05H21.6367Z",
    fill: "#98A2B3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12.7273,
    width: 28,
    height: 12.7273,
    rx: 1.08815,
    fill: "#CC400C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01562 22.2562V15.9252H8.38977C8.87614 15.9252 9.2842 16.0159 9.61394 16.1972C9.94574 16.3786 10.1961 16.6279 10.3651 16.9453C10.5362 17.2606 10.6217 17.6192 10.6217 18.0211C10.6217 18.4271 10.5362 18.7877 10.3651 19.1031C10.1941 19.4184 9.94162 19.6667 9.60776 19.8481C9.27389 20.0274 8.86274 20.117 8.37431 20.117H6.80082V19.1742H8.21975C8.50415 19.1742 8.73703 19.1247 8.91839 19.0258C9.09975 18.9269 9.23371 18.7908 9.32026 18.6177C9.40888 18.4446 9.45319 18.2457 9.45319 18.0211C9.45319 17.7965 9.40888 17.5986 9.32026 17.4276C9.23371 17.2565 9.09872 17.1236 8.9153 17.0288C8.73394 16.9319 8.50003 16.8835 8.21356 16.8835H7.16251V22.2562H6.01562Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7633 22.2562H11.6179V15.9252H13.8066C14.4351 15.9252 14.9751 16.0519 15.4264 16.3054C15.8798 16.5568 16.2281 16.9185 16.4713 17.3905C16.7145 17.8624 16.8361 18.4271 16.8361 19.0845C16.8361 19.744 16.7134 20.3107 16.4682 20.7847C16.225 21.2588 15.8736 21.6225 15.4141 21.876C14.9565 22.1295 14.4063 22.2562 13.7633 22.2562ZM12.7648 21.2639H13.7076C14.1487 21.2639 14.5165 21.1835 14.8112 21.0228C15.106 20.86 15.3275 20.6178 15.4759 20.2963C15.6243 19.9728 15.6985 19.5688 15.6985 19.0845C15.6985 18.6002 15.6243 18.1983 15.4759 17.8789C15.3275 17.5574 15.108 17.3173 14.8174 17.1586C14.5289 16.9979 14.1703 16.9175 13.7416 16.9175H12.7648V21.2639Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9258 22.2562V15.9252H21.9816V16.8866H19.0727V18.6054H21.7034V19.5668H19.0727V22.2562H17.9258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.0046b133bb8355208d8bb0036c01fa85.svg";
export { ForwardRef as ReactComponent };